import { ReactElement } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useRestoreSession } from "../../../hooks/useRestoreSession";
import RoutePopup from "../../RoutePopup";
import { useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: ReactElement;
}

function ProtectedAdminRoute({ children }: ProtectedRouteProps): ReactElement {
    const { user } = useSelector((state: RootState) => state.auth);
    const { isLoading } = useRestoreSession();
    const navigate = useNavigate();
    console.log("User in ProtectedAdminRoute:", user);
    const isAdmin = user?.roles.includes('admin');
    if (isLoading) return <></>;

    if (!isAdmin) {
        return (
            <RoutePopup
                onClose={() => {
                    navigate("/");
                }}
            />
        );
    }

    return children;
}

export default ProtectedAdminRoute;
